import type {
  SearchFieldDialogAction,
  SearchFieldDialogActionContext
} from '@/components/custom/erp/search-field-v2/types';

interface BuildQuickCreateDialogActionsOptions<TData> {
  allowEdit?: boolean;
  createIcon?: number;
  createTitle?: string;
  editIcon?: number;
  editTitle?: string;
  initialData?: TData | null;
  onCreate: (context: SearchFieldDialogActionContext<TData>) => void;
  onEdit?: (item: TData, context: SearchFieldDialogActionContext<TData>) => void;
}

export const buildQuickCreateDialogActions = <TData>({
  allowEdit = true,
  createIcon = 7,
  createTitle = 'Thêm mới',
  editIcon = 9,
  editTitle = 'Chỉnh sửa',
  initialData,
  onCreate,
  onEdit
}: BuildQuickCreateDialogActionsOptions<TData>): SearchFieldDialogAction<TData>[] => {
  const actions: SearchFieldDialogAction<TData>[] = [
    {
      icon: createIcon,
      key: 'quick-create',
      onClick: onCreate,
      title: createTitle
    }
  ];

  if (allowEdit && onEdit) {
    actions.push({
      disabled: ({ selectedRow }) => !(selectedRow ?? initialData),
      icon: editIcon,
      key: 'quick-edit',
      onClick: context => {
        const item = context.selectedRow ?? initialData;

        if (item) {
          onEdit(item, context);
        }
      },
      title: editTitle
    });
  }

  return actions;
};
